/* Ardor Printing AI real estate sign generator (sections/ardor-realestate-idea.liquid, template
   page.ai-real-estate-sign-generator). 2026-10-19. Ported from the AI banner stand generator (assets/ardor-stand-idea.js,
   itself from the AI table throw, flag and banner generators): same look, Turnstile and email-unlock flow, the same
   visitor id + email (localStorage wsIdeaVisitor / wsIdeaEmail) and the same worker routes and counters
   (/api/banner/quota, /logo, /generate with product "banner", /fix, /final), so tries are shared with the other tools.
   The customer picks a real estate sign (keys as in the real estate sign designer: YS*, RA*, RP*, RF*), what to design
   (the sign or its rider, on signs with riders), the rider size and the side. The worker is asked for the VISIBLE area of
   that face in feet (it clamps the drawing to 3:1 with plain extendable ends: riders are 4:1 or wider); each design is
   shown on a picture of the sign in its hardware, ends filled from the design's own edges (composeEnds), plus the flat
   artwork. Real estate idea chips (For Sale, Open House, Sold...) fill an editable headline, style and style notes.
   "Use this design" -> /api/banner/final -> <builder>?ai=<finalId>&sign=<KEY>&face=<front|back|rider-front|rider-back>
   [&rider=<size> on rider faces][&ends=smooth][&logo=<logoId>&lb=x0,y0,x1,y1], plus sessionStorage ardorRealestateAiPick
   (format: RE-AI ai/HANDOFF.md). Before redirecting it fires a cancelable "ardor:realestate-ai-handoff" event on the
   section (detail.url, detail.pick); calling preventDefault() on it stops the redirect (used for testing).
   No jQuery and no libraries except Cloudflare Turnstile. */
(function () {
  'use strict';
  const root = document.querySelector('[data-ardor-realestate-ai]');
  if (!root || root.dataset.abiReady) return;
  root.dataset.abiReady = '1';

  const $ = (s, c = root) => c.querySelector(s);
  const $$ = (s, c = root) => Array.from(c.querySelectorAll(s));
  const API = (root.dataset.api || '').replace(/\/+$/, '');
  const SITEKEY = root.dataset.turnstile || '';
  const BUILDER = root.dataset.builder || '/products/custom-real-estate-signs';
  const MIN_FT = 0.5; // the worker's banner mode takes 0.5 .. 200 ft per side
  const MAX_FT = 200;
  const MAX_LOGO_PX = 1536;
  const MAX_LOGO_BYTES = 8 * 1024 * 1024;
  const MAX_SOURCE_BYTES = 30 * 1024 * 1024;
  const LIMITS = { headline: 60, subline: 80, details: 120, notes: 300, fix: 200 };
  const STYLES = { bold: 'Bold', clean: 'Clean', fun: 'Fun', elegant: 'Elegant', vintage: 'Vintage', event: 'Event' };
  const LAST_KEY = 'ardorRealestateAiLast';
  const PICK_KEY = 'ardorRealestateAiPick';
  // [seconds, status text, step index (Layout, Your words, Spell check, Final touches), only when]
  const GEN_STEPS = [
    [0, 'Laying out your sign…', 0],
    [10, 'Setting your words…', 1],
    [22, 'Placing your logo…', 1, 'logo'],
    [34, 'Checking the spelling…', 2],
    [50, 'Double-checking every word…', 2],
    [66, 'Adding the final touches…', 3],
    [82, 'Almost there…', 3]
  ];

  /* ---------- storage (same keys as the sticker generator for visitor + email) ---------- */
  const store = {
    get(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* private mode */ } }
  };
  const sget = (k) => { try { return JSON.parse(window.sessionStorage.getItem(k) || 'null'); } catch (e) { return null; } };
  const sset = (k, v) => { try { window.sessionStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* full or blocked */ } };

  let visitor = store.get('wsIdeaVisitor');
  if (!visitor || !/^[a-zA-Z0-9_-]{8,64}$/.test(visitor)) {
    visitor = (window.crypto && crypto.randomUUID ? crypto.randomUUID() : String(Date.now()) + Math.random().toString(36).slice(2)).replace(/[^a-zA-Z0-9_-]/g, '');
    store.set('wsIdeaVisitor', visitor);
  }
  let email = store.get('wsIdeaEmail') || '';

  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (e) { /* ignore */ }
  }

  /* ---------- elements ---------- */
  const form = $('[data-abi-form]');
  const famChips = $$('[data-are-fams] .abi__chip');
  const row1 = $('[data-are-row1]');
  const row2 = $('[data-are-row2]');
  const row3 = $('[data-are-row3]');
  const sub1 = $('[data-are-sub1]');
  const sub2 = $('[data-are-sub2]');
  const sub3 = $('[data-are-sub3]');
  const faceRow = $('[data-are-faces]');
  const sub4 = $('[data-are-sub4]');
  const shapeCv = $('[data-are-shape-cv]');
  const shapeLabel = $('[data-abi-shape-label]');
  const sizeNote = $('[data-abi-size-note]');
  const sizeErr = $('[data-abi-size-err]');
  const drop = $('[data-abi-drop]');
  const fileIn = $('[data-abi-file]');
  const logoRow = $('[data-abi-logo]');
  const logoImg = $('[data-abi-logo-img]');
  const logoName = $('[data-abi-logo-name]');
  const logoInfo = $('[data-abi-logo-info]');
  const logoErr = $('[data-abi-logo-err]');
  const lineIns = { headline: $('[data-abi-line="headline"]'), subline: $('[data-abi-line="subline"]'), details: $('[data-abi-line="details"]') };
  const headErr = $('[data-abi-headline-err]');
  const notesIn = $('[data-abi-notes]');
  const styleBtns = $$('[data-style]');
  const goBtn = $('[data-abi-go]');
  const goLabel = $('[data-abi-go-label]');
  const quotaEl = $('[data-abi-quota]');
  const errEl = $('[data-abi-err]');
  const results = $('[data-abi-results]');
  const metaEl = $('[data-abi-meta]');
  const echo = $('[data-abi-echo]');
  const h2 = $('[data-abi-h2]');
  const statusEl = $('[data-abi-status]');
  const loading = $('[data-abi-loading]');
  const bar = $('[data-abi-bar]');
  const stepEls = $$('[data-abi-steps] li');
  const grid = $('[data-abi-grid]');
  const againRow = $('[data-abi-again-row]');
  const againBtn = $('[data-abi-again]');
  const editBtn = $('[data-abi-edit]');
  const fineEl = $('.abi__fine');
  const gate = $('[data-abi-gate]');
  const gateForm = $('[data-abi-gate-form]');
  const gateEmail = $('[data-abi-email]');
  const gateErr = $('[data-abi-gate-err]');
  const gateN = $('[data-abi-gate-n]');

  const S = {
    sign: 'YS-24x18', face: 'front', rider: null, idea: '', w: 0, h: 0, style: 'bold',
    logo: null, // { blob, w, h, name, id, thumb (object URL or data URL), thumbData }
    batch: null, // { batchId, aspect, clamped, w, h, style, notes, lines, logoId, images }
    busy: false, off: false,
    bannersLeft: null, fixesLeft: null, finalsLeft: null,
    hasEmail: !!email, freeBanners: 2, emailBanners: 10,
    pending: null
  };

  if (!API) {
    goBtn.disabled = true;
    quotaEl.hidden = true;
    return;
  }

  /* ---------- small helpers ---------- */
  const clean = (s) => String(s || '').replace(/\s+/g, ' ').trim();
  const round2 = (n) => Math.round(n * 100) / 100;
  const fmt = (n) => String(round2(n));
  const sizeLabel = (w, h) => `${fmt(w)} x ${fmt(h)} ft`;
  const num = (v) => { const n = parseFloat(String(v).replace(',', '.')); return Number.isFinite(n) ? n : NaN; };
  const validFt = (n) => Number.isFinite(n) && n >= MIN_FT && n <= MAX_FT;
  const clampAr = (a) => Math.min(3, Math.max(1 / 3, a));
  const shapeOf = (a) => (a >= 6 ? 'xwide' : a >= 1.3 ? 'wide' : a > 0.77 ? 'square' : 'tall');
  const enc = encodeURIComponent;

  /* ---------- real estate signs ---------- */
  // Keys match the real estate sign designer (/products/custom-real-estate-signs) and specs/re-specs.json (RE-SPECS,
  // measured on the templates). Per sign: k = key, f = family (yard | aframe | post | frame), n = full name, s = short
  // name, b = size label, bs = small note on the size chip, p = sign faces [id, w, h]: the VISIBLE area (what shows
  // on the installed sign) in inches, t = the sign's template [w, h, visible x, visible y] when the visible area is
  // smaller (frame lip), h = sign holes [cx, cy, dia] in template inches, r = riders { size: [[id, w, h], ...] } (faces
  // rider-front / rider-back), rt = rider templates { size: [w, h, vx, vy] }, rd = default rider size, rp = where the
  // rider goes (arm = on top of the post arm, top = in the clamp on top of the A-frame, below = under the sign in the
  // frame), md = hardware modelling numbers (specs), d: 1 = default for its family, ph: 1 = provisional.
  const FAMILIES = {
    yard: { label: 'Yard sign', noun: 'yard sign' },
    aframe: { label: 'A-frame', noun: 'A-frame sign' },
    post: { label: 'Post', noun: 'post sign' },
    frame: { label: 'Frame', noun: 'frame sign' }
  };
  const FACE_NAMES = { front: 'Front', back: 'Back', 'rider-front': 'Rider front', 'rider-back': 'Rider back' };
  // generated by ai/tools/gen_signs.py from specs/re-specs.json (status final)
  const SIGNS = [
    {k: "YS-24x18", f: "yard", n: "Yard Sign and H-Stake - 24 x 18 in sign", s: "24 x 18 in yard sign", b: "24 x 18 in", p: [["front", 24, 18], ["back", 24, 18]], md: {"wireDia": 0.16, "legSpacing": 10, "totalHeight": 30, "insertIntoSign": 10, "crossbarBelowSign": 8.5, "inGround": 11.5}, d: 1},
    {k: "RA-24x18", f: "aframe", n: "Real Estate A-Frame - 24 x 18 in sign", s: "24 x 18 in A-frame sign", b: "24 x 18 in", p: [["front", 24, 18], ["back", 24, 18]], h: [[1, 1, 0.4], [23, 1, 0.4]], r: {"24x6": [["rider-front", 24, 6], ["rider-back", 24, 6]]}, rd: "24x6", rp: "top", md: {"topBarWidth": 27, "heightToTopBar": 31, "handleRise": 2.5, "handleWidth": 13, "footSpread": 20, "wireDia": 0.25, "signTopBelowTopBar": 1}, d: 1},
    {k: "RP-24x18", f: "post", n: "Real Estate Post - 24 x 18 in sign (Small Post)", s: "24 x 18 in post sign", b: "24 x 18 in", bs: "small post", p: [["front", 24, 18], ["back", 24, 18]], h: [[4, 1.35, 0.25], [20, 1.35, 0.25]], r: {"24x6": [["rider-front", 24, 6], ["rider-back", 24, 6]]}, rd: "24x6", rp: "arm", md: {"postSize": 4, "postHeight": 72, "armLength": 38, "armSize": 3.5, "armBackOverhang": 1.6, "armTopFromGround": 65.5, "signGapFromPost": 4, "signTopBelowArm": 1.5}, d: 1},
    {k: "RP-24x24", f: "post", n: "Real Estate Post - 24 x 24 in sign (Small Post)", s: "24 x 24 in post sign", b: "24 x 24 in", bs: "small post", p: [["front", 24, 24], ["back", 24, 24]], h: [[4, 1.35, 0.25], [20, 1.35, 0.25]], r: {"24x6": [["rider-front", 24, 6], ["rider-back", 24, 6]]}, rd: "24x6", rp: "arm", md: {"postSize": 4, "postHeight": 72, "armLength": 38, "armSize": 3.5, "armBackOverhang": 1.6, "armTopFromGround": 65.5, "signGapFromPost": 4, "signTopBelowArm": 1.5}},
    {k: "RP-24x30", f: "post", n: "Real Estate Post - 24 x 30 in sign (Small Post)", s: "24 x 30 in post sign", b: "24 x 30 in", bs: "small post", p: [["front", 24, 30], ["back", 24, 30]], h: [[4, 1.35, 0.25], [20, 1.35, 0.25]], r: {"24x6": [["rider-front", 24, 6], ["rider-back", 24, 6]]}, rd: "24x6", rp: "arm", md: {"postSize": 4, "postHeight": 72, "armLength": 38, "armSize": 3.5, "armBackOverhang": 1.6, "armTopFromGround": 65.5, "signGapFromPost": 4, "signTopBelowArm": 1.5}},
    {k: "RP-24x36", f: "post", n: "Real Estate Post - 24 x 36 in sign (Small Post)", s: "24 x 36 in post sign", b: "24 x 36 in", bs: "small post", p: [["front", 24, 36], ["back", 24, 36]], h: [[4, 1.35, 0.25], [20, 1.35, 0.25]], r: {"24x6": [["rider-front", 24, 6], ["rider-back", 24, 6]]}, rd: "24x6", rp: "arm", md: {"postSize": 4, "postHeight": 72, "armLength": 38, "armSize": 3.5, "armBackOverhang": 1.6, "armTopFromGround": 65.5, "signGapFromPost": 4, "signTopBelowArm": 1.5}},
    {k: "RP-36x24", f: "post", n: "Real Estate Post - 36 x 24 in sign (Large Post)", s: "36 x 24 in post sign", b: "36 x 24 in", bs: "large post", p: [["front", 36, 24], ["back", 36, 24]], h: [[6, 2, 0.25], [30, 2, 0.25]], r: {"36x6": [["rider-front", 36, 6], ["rider-back", 36, 6]]}, rd: "36x6", rp: "arm", md: {"postSize": 4, "postHeight": 72, "armLength": 52, "armSize": 3.5, "armBackOverhang": 1.6, "armTopFromGround": 65.5, "signGapFromPost": 4.5, "signTopBelowArm": 1.5}},
    {k: "RP-36x36", f: "post", n: "Real Estate Post - 36 x 36 in sign (Large Post)", s: "36 x 36 in post sign", b: "36 x 36 in", bs: "large post", p: [["front", 36, 36], ["back", 36, 36]], h: [[6, 2, 0.25], [30, 2, 0.25]], r: {"36x6": [["rider-front", 36, 6], ["rider-back", 36, 6]]}, rd: "36x6", rp: "arm", md: {"postSize": 4, "postHeight": 72, "armLength": 52, "armSize": 3.5, "armBackOverhang": 1.6, "armTopFromGround": 65.5, "signGapFromPost": 4.5, "signTopBelowArm": 1.5}},
    {k: "RP-36x48", f: "post", n: "Real Estate Post - 36 x 48 in sign (Large Post)", s: "36 x 48 in post sign", b: "36 x 48 in", bs: "large post", p: [["front", 36, 48], ["back", 36, 48]], h: [[6, 2, 0.25], [30, 2, 0.25]], r: {"36x6": [["rider-front", 36, 6], ["rider-back", 36, 6]]}, rd: "36x6", rp: "arm", md: {"postSize": 4, "postHeight": 72, "armLength": 52, "armSize": 3.5, "armBackOverhang": 1.6, "armTopFromGround": 65.5, "signGapFromPost": 4.5, "signTopBelowArm": 1.5}},
    {k: "RF-24x18", f: "frame", n: "Real Estate Frame - 24 x 18 in sign", s: "24 x 18 in frame sign", b: "24 x 18 in", p: [["front", 22.5, 16.5], ["back", 22.5, 16.5]], t: [24, 18, 0.75, 0.75], r: {"24x6": [["rider-front", 22.5, 4.5], ["rider-back", 22.5, 4.5]]}, rd: "24x6", rt: {"24x6": [24, 6, 0.75, 0.75]}, rp: "below", md: {"tube": 0.6, "innerWidth": 24.05, "topBarY": 0, "signTop": 0.3, "midBarY": 18.4, "riderTop": 19, "lowBarY": 25.2, "stepTabY": 33, "stepTabLen": 1.2, "legBottom": 43}, d: 1}
  ];
  const DEFAULT_SIGN = 'YS-24x18';
  const signOf = (k) => SIGNS.find((c) => c.k === k) || null;
  const famOf = (c) => FAMILIES[c.f] || FAMILIES.yard;
  const isRider = (id) => /^rider-/.test(String(id || ''));
  const riderSizes = (c) => (c && c.r ? Object.keys(c.r) : []);
  // the rider size to use on sign c: the asked one when the sign has it, else its default, else its first, else null
  const riderOf = (c, size) => {
    if (!c || !c.r) return null;
    if (size && c.r[size]) return size;
    return c.rd && c.r[c.rd] ? c.rd : riderSizes(c)[0] || null;
  };
  // faces [id, w, h] of the piece (sign or rider) face id belongs to
  const piecesOf = (c, id, size) => {
    if (!c) return [];
    if (!isRider(id)) return c.p;
    const rs = riderOf(c, size);
    return rs ? c.r[rs] : [];
  };
  const faceOf = (c, id, size) => piecesOf(c, id, size).find((q) => q[0] === id) || null;
  const faceName = (id) => FACE_NAMES[id] || FACE_NAMES.front;
  const sideName = (id) => (/back$/.test(String(id || '')) ? 'Back' : 'Front');
  const fmtIn = (n) => String(Math.round(n * 100) / 100);
  const sizeIn = (s) => `${String(s).replace('x', ' x ')} in`;
  // "24 x 18 in post sign" / "24 x 6 in rider"
  const pieceName = (c, id, size) => (isRider(id) && riderOf(c, size) ? `${sizeIn(riderOf(c, size))} rider` : c.s);
  const signLabel = (k, id, size) => {
    const c = signOf(k) || signOf(DEFAULT_SIGN);
    return `${pieceName(c, id, size)}${piecesOf(c, id, size).length > 1 ? ` · ${sideName(id)}` : ''}`;
  };
  const signShort = (b) => { const c = signOf(b.sign) || signOf(DEFAULT_SIGN); return pieceName(c, b.face, b.rider); };
  // What the worker is asked for (feet): the visible area of the face. The worker's banner mode takes 0.5 .. 200 ft a
  // side and draws at most 3:1 (or 1:3), keeping the outer ends plain; riders (4:1, 6:1) get their ends filled from the
  // design's own edges. A side under 0.5 ft (a rider shorter than 6 in) scales both sides up: same shape.
  function reqOf(c, id, size) {
    const q = faceOf(c, id, size) || c.p[0];
    let w = q[1] / 12, h = q[2] / 12;
    const lo = Math.min(w, h);
    if (lo < MIN_FT) { const k = MIN_FT / lo; w *= k; h *= k; }
    w = Math.max(MIN_FT, round2(w));
    h = Math.max(MIN_FT, round2(h));
    return { w, h, pw: q[1], ph: q[2], face: q[0], scaled: lo < MIN_FT };
  }

  // ---- drawing: the sign in its hardware, front view, with the design on the face being designed ----
  // Inches, x = 0 at the sign's centre, y down with the ground at y = 0.
  function panelArt(img, pw, ph, smooth, px, mark) {
    if (img) return composeEnds(img, pw / ph, smooth, Math.max(48, Math.min(1400, Math.round(px))));
    const cv = mkC(Math.max(60, Math.round(px * (pw > ph ? pw / ph : 1))), Math.max(60, Math.round(px * (ph > pw ? ph / pw : 1))));
    const x = cv.getContext('2d');
    x.fillStyle = '#f7d9db';
    x.fillRect(0, 0, cv.width, cv.height);
    if (mark) {
      x.fillStyle = '#b3141f';
      x.textAlign = 'center';
      x.textBaseline = 'middle';
      if (cv.width / cv.height > 2.6) {
        const fs = Math.min(cv.width / 9, cv.height / 2);
        x.font = `800 ${Math.round(fs)}px Unbounded, Arial, sans-serif`;
        x.fillText('YOUR DESIGN', cv.width / 2, cv.height / 2);
      } else {
        const fs = Math.min(cv.width / 6.4, cv.height / 3.2);
        x.font = `800 ${Math.round(fs)}px Unbounded, Arial, sans-serif`;
        x.fillText('YOUR', cv.width / 2, cv.height / 2 - fs * 0.6);
        x.fillText('DESIGN', cv.width / 2, cv.height / 2 + fs * 0.6);
      }
    }
    return cv;
  }
  // rounded rectangle path
  function rr(x, x0, y0, w, h, r) {
    x.beginPath();
    r = Math.max(0, Math.min(r, w / 2, h / 2));
    x.moveTo(x0 + r, y0);
    x.arcTo(x0 + w, y0, x0 + w, y0 + h, r);
    x.arcTo(x0 + w, y0 + h, x0, y0 + h, r);
    x.arcTo(x0, y0 + h, x0, y0, r);
    x.arcTo(x0, y0, x0 + w, y0, r);
    x.closePath();
  }
  // template page of a piece: [w, h, visible x, visible y] (the visible area fills the page when there is no t / rt)
  const tplOf = (c, rs) => {
    if (rs) { const q = c.r[rs][0]; return (c.rt && c.rt[rs]) || [q[1], q[2], 0, 0]; }
    return c.t || [c.p[0][1], c.p[0][2], 0, 0];
  };
  // Layout of sign c when face id is designed (rider size for rider faces), from the specs' modelling numbers (md).
  // g.sign / g.rider = [x, y, w, h] of the template pages (g.rider only when a rider face is designed), g.box = picture
  // bounds, g.dir = -1 mirrors the post (back faces), so the post stands on the other side.
  function signGeo(c, id, size) {
    const M = c.md || {}, f = c.f;
    const st = tplOf(c, null), W = st[0], H = st[1];
    const rs = isRider(id) ? riderOf(c, size) : null;
    const rt = rs ? tplOf(c, rs) : null;
    const g = { f, W, H, dir: /back$/.test(String(id || '')) && f === 'post' ? -1 : 1, rider: null, rp: c.rp || 'below', holes: c.h || [] };
    let top, left = -W / 2, right = W / 2;
    if (f === 'post') {
      g.pw = M.postSize || 4;
      g.armT = M.armSize || 3.5;
      g.armY = -(M.armTopFromGround || 65.5);         // top of the arm
      g.postTop = -(M.postHeight || 72);
      const gap = M.signGapFromPost || 4;
      g.sign = [-W / 2, g.armY + g.armT + (M.signTopBelowArm || 1.5), W, H];
      g.px = -W / 2 - gap - g.pw / 2;                 // post centre (before mirroring)
      g.armX0 = g.px - g.pw / 2 - (M.armBackOverhang || 1.6);
      g.armX1 = g.px + g.pw / 2 + (M.armLength || (W >= 30 ? 52 : 38));
      if (rt) g.rider = [-rt[0] / 2, g.armY - rt[1], rt[0], rt[1]];   // stands on top of the arm, clipped at its bottom edge
      top = Math.min(g.postTop - 1.8, g.rider ? g.rider[1] : 0) - 0.5;
      left = Math.min(g.armX0, -W / 2) - 0.5;
      right = Math.max(g.armX1, W / 2) + 0.5;
    } else if (f === 'frame') {
      g.tube = M.tube || 0.6;
      const ground = M.stepTabY || 33, y = (v) => v - ground; // spec y (down from the top bar) -> picture y
      g.fw = (M.innerWidth || W + 0.05) + g.tube * 2;
      g.topY = y(M.topBarY || 0);
      g.midY = y(M.midBarY || 18.4);
      g.lowY = y(M.lowBarY || 25.2);
      g.sign = [-W / 2, y(M.signTop == null ? 0.3 : M.signTop), W, H];
      if (rt) g.rider = [-rt[0] / 2, y(M.riderTop || 19), rt[0], rt[1]];
      top = g.topY - 1.2;
      left = -g.fw / 2 - 1;
      right = -left;
    } else if (f === 'aframe') {
      g.bar = M.topBarWidth || 27;
      g.barY = -(M.heightToTopBar || 31);
      g.hw = M.handleWidth || 13;
      g.hr = M.handleRise || 2.5;
      g.wire = Math.max(0.35, M.wireDia || 0.25);
      g.sign = [-W / 2, g.barY + (M.signTopBelowTopBar || 1), W, H];
      if (rt) g.rider = [-rt[0] / 2, g.barY - g.hr - 0.6 - rt[1], rt[0], rt[1]]; // stands in the clamp on top of the handle
      top = Math.min(g.barY - g.hr, g.rider ? g.rider[1] : 0) - 1.5;
      left = -Math.max(g.bar, W, rt ? rt[0] : 0) / 2 - 1.5;
      right = -left;
    } else {                                          // yard sign on an H-stake: legs slide into the flutes
      const lift = (M.totalHeight || 30) - (M.inGround || 11.5) - (M.insertIntoSign || 10);
      g.sign = [-W / 2, -Math.max(4, lift) - H, W, H];
      g.leg = (M.legSpacing || 10) / 2;
      g.wire = Math.max(0.3, M.wireDia || 0.16);
      top = g.sign[1] - 1;
    }
    if (g.dir < 0) { const l = left; left = -right; right = -l; }
    const pad = Math.max(right - left, -top) * 0.04;
    g.box = [left - pad, top - pad, right + pad, 2.4];
    if (g.rider) {
      // rider faces: frame the sign and the rider (the rider is what is being designed), not the whole post or legs
      const ys = [g.sign[1], g.sign[1] + g.sign[3], g.rider[1], g.rider[1] + g.rider[3]];
      const y0 = Math.min(...ys) - (f === 'aframe' ? 1.5 : 3), y1 = Math.max(...ys) + 4;
      g.box = [g.box[0], y0, g.box[2], Math.min(2.4, y1)];
    }
    return g;
  }
  const signAspect = (c, id, size) => { const b = signGeo(c, id, size).box; return (b[2] - b[0]) / (b[3] - b[1]); };
  // results cards: the picture beside the flat art (signs) or above it (riders: the flat art is wide)
  const frameArOf = () => 1;
  const layoutOf = (b) => (isRider(b.face) ? 'col' : 'row');
  function drawSignParts(x, c, g, art, k, onRider, rs) {
    const lw = 1.2 / k, f = g.f, d = g.dir;
    const steel = (y0, y1) => {
      const lg = x.createLinearGradient(0, y0, 0, y1);
      lg.addColorStop(0, '#8a8f98'); lg.addColorStop(0.5, '#62676f'); lg.addColorStop(1, '#474b52');
      return lg;
    };
    const pvc = (x0, x1) => {
      const lg = x.createLinearGradient(x0, 0, x1, 0);
      lg.addColorStop(0, '#ffffff'); lg.addColorStop(0.55, '#eceef1'); lg.addColorStop(1, '#c9cdd3');
      return lg;
    };
    // ground: soft shadow
    x.fillStyle = 'rgba(0,0,0,.28)';
    x.beginPath();
    const sw = (g.box[2] - g.box[0]) * 0.44;
    x.ellipse((g.box[0] + g.box[2]) / 2, 0.2, sw, Math.max(0.6, Math.min(2.2, sw * 0.06)), 0, 0, Math.PI * 2);
    x.fill();
    // one printed piece: page rect r, template t = [w, h, vx, vy]; the art fills the visible area and its edges are
    // stretched over the rest of the page (as the designer fills it). No art: a plain sign with grey lines.
    const face = (r, t, a, round) => {
      const [sx, sy, w, h] = r;
      x.save();
      rr(x, sx, sy, w, h, round || 0); x.clip();
      if (a) {
        const vw = w - t[2] * 2, vh = h - t[3] * 2;
        if (t[2] > 0 || t[3] > 0) x.drawImage(a, sx, sy, w, h);
        x.drawImage(a, sx + t[2], sy + t[3], vw, vh);
      } else {
        x.fillStyle = '#eceef2'; x.fillRect(sx, sy, w, h);
        x.fillStyle = 'rgba(0,0,0,.08)';
        const n = Math.max(2, Math.round(h / 5));
        for (let i = 1; i < n; i++) x.fillRect(sx + w * 0.14, sy + (h * i) / n - h * 0.02, w * 0.72, h * 0.04);
      }
      x.restore();
      x.lineWidth = lw; x.strokeStyle = 'rgba(0,0,0,.35)';
      rr(x, sx, sy, w, h, round || 0); x.stroke();
    };
    const st = tplOf(c, null), rt = rs ? tplOf(c, rs) : null;
    const signArt = onRider ? null : art, riderArt = onRider ? art : null;
    const holeAt = (hh) => [g.sign[0] + hh[0], g.sign[1] + hh[1]];
    if (f === 'yard') {
      // H-stake: two wire legs from the sign's flutes into the ground, cross wire under the sign
      const ys = g.sign[1] + g.sign[3];
      x.strokeStyle = '#a9aeb6'; x.lineCap = 'round'; x.lineWidth = g.wire;
      x.beginPath();
      [-g.leg, g.leg].forEach((lx) => { x.moveTo(lx, ys - 0.5); x.lineTo(lx, 0.6); });
      x.moveTo(-g.leg, ys + 0.6); x.lineTo(g.leg, ys + 0.6);
      x.stroke();
      face(g.sign, st, signArt, 0.15);
    } else if (f === 'aframe') {
      const hb = g.bar / 2, by = g.barY, wr = g.wire;
      x.strokeStyle = '#6f747c'; x.lineCap = 'round'; x.lineJoin = 'round'; x.lineWidth = wr * 1.6;
      // legs and the top bar, handle loop above it
      x.beginPath();
      x.moveTo(-hb + 0.8, 0.3); x.lineTo(-hb, by); x.lineTo(hb, by); x.lineTo(hb - 0.8, 0.3);
      x.moveTo(-g.hw / 2, by); x.lineTo(-g.hw / 2 + 1, by - g.hr); x.lineTo(g.hw / 2 - 1, by - g.hr); x.lineTo(g.hw / 2, by);
      x.stroke();
      // zip ties from the top bar to the grommets
      x.strokeStyle = '#d6d9de'; x.lineWidth = Math.max(0.12, wr * 0.5);
      (g.holes.length ? g.holes : [[1, 1, 0.4], [g.W - 1, 1, 0.4]]).forEach((hh) => { const [hx, hy] = holeAt(hh); x.beginPath(); x.moveTo(hx, hy); x.lineTo(hx, by); x.stroke(); });
      face(g.sign, st, signArt, 0.15);
      (g.holes.length ? g.holes : [[1, 1, 0.4], [g.W - 1, 1, 0.4]]).forEach((hh) => { const [hx, hy] = holeAt(hh); x.beginPath(); x.arc(hx, hy, Math.max(0.25, hh[2] * 0.9), 0, Math.PI * 2); x.fillStyle = '#c9ccd2'; x.fill(); x.lineWidth = 0.12; x.strokeStyle = '#555'; x.stroke(); });
      if (g.rider) {
        face(g.rider, rt, riderArt, 0.15);
        x.fillStyle = '#5d626b'; rr(x, -1.6, g.rider[1] + g.rider[3] - 1.2, 3.2, 2.2 + g.hr * 0, 0.4); x.fill();
      }
    } else if (f === 'frame') {
      const t = g.tube, hx = g.fw / 2 - t / 2;
      face(g.sign, st, signArt, 0);
      if (g.rider) face(g.rider, rt, riderArt, 0);
      // side tubes become the stake legs; top, middle and low bars
      x.fillStyle = steel(g.topY, 0);
      [-hx, hx].forEach((cx) => x.fillRect(cx - t / 2, g.topY - t / 2, t, -g.topY + t / 2 + 0.6));
      [g.topY, g.midY, g.lowY].forEach((yy) => x.fillRect(-hx, yy - t / 2, hx * 2, t));
      x.lineWidth = lw; x.strokeStyle = 'rgba(255,255,255,.22)';
      [-hx, hx].forEach((cx) => x.strokeRect(cx - t / 2, g.topY - t / 2, t, -g.topY + t / 2));
    } else if (f === 'post') {
      const pw = g.pw, px = g.px * d, top = g.postTop, ay = g.armY, at = g.armT;
      // post with its cap, arm across the top
      x.fillStyle = pvc(px - pw / 2, px + pw / 2);
      x.fillRect(px - pw / 2, top, pw, -top + 0.4);
      x.fillStyle = '#f4f5f7';
      x.beginPath(); x.moveTo(px - pw / 2 - 0.5, top); x.lineTo(px, top - 1.6); x.lineTo(px + pw / 2 + 0.5, top); x.closePath(); x.fill();
      x.fillRect(px - pw / 2 - 0.5, top, pw + 1, 0.8);
      const ax0 = d > 0 ? g.armX0 : -g.armX1, ax1 = d > 0 ? g.armX1 : -g.armX0;
      const lg = x.createLinearGradient(0, ay, 0, ay + at);
      lg.addColorStop(0, '#ffffff'); lg.addColorStop(1, '#cfd3d9');
      x.fillStyle = lg;
      x.fillRect(ax0, ay, ax1 - ax0, at);
      x.fillStyle = '#f4f5f7';
      x.fillRect(d > 0 ? ax1 - 0.5 : ax0 - 0.3, ay - 0.3, 0.8, at + 0.6);
      x.lineWidth = lw; x.strokeStyle = 'rgba(0,0,0,.25)';
      x.strokeRect(px - pw / 2, top, pw, -top); x.strokeRect(ax0, ay, ax1 - ax0, at);
      // S-hooks from the arm to the sign's holes
      const [sx, sy, w] = g.sign;
      const holes = g.holes.length ? g.holes : [[Math.min(4, w * 0.17), 1.35, 0.25], [w - Math.min(4, w * 0.17), 1.35, 0.25]];
      x.strokeStyle = '#b9bec6'; x.lineWidth = Math.max(0.2, w * 0.008);
      holes.forEach((hh) => { const [hx, hy] = holeAt(hh); x.beginPath(); x.moveTo(hx, ay + at); x.lineTo(hx, hy - 0.4); x.stroke(); x.beginPath(); x.arc(hx, hy, Math.max(0.3, hh[2]), 0, Math.PI * 2); x.stroke(); });
      face(g.sign, st, signArt, 0.25);
      holes.forEach((hh) => { const [hx, hy] = holeAt(hh); x.beginPath(); x.arc(hx, hy, Math.max(0.18, hh[2] / 2), 0, Math.PI * 2); x.fillStyle = '#6b7079'; x.fill(); });
      if (g.rider) {
        const [rx, ry, rw, rh] = g.rider;
        face(g.rider, rt, riderArt, 0.2);
        // small clips on the arm top hold the rider's bottom edge
        x.fillStyle = '#c4c8cf';
        [rx + rw * 0.15, rx + rw * 0.85].forEach((cx) => { rr(x, cx - 0.5, ry + rh - 0.75, 1, 1.1, 0.25); x.fill(); });
      }
    }
  }
  // Draws sign key with the design (img) on face id (rider size for rider faces), filled the way the designer fills it
  // (composeEnds). img = null + mark = the step 1 picture with "YOUR DESIGN" on the face. Fits wPx x hPx.
  function drawSign(cv, img, key, id, size, smooth, wPx, hPx, mark) {
    const c = signOf(key) || signOf(DEFAULT_SIGN);
    const fid = faceOf(c, id, size) ? id : 'front';
    const q = faceOf(c, fid, size) || c.p[0];
    const g = signGeo(c, fid, size);
    const [bx0, by0, bx1, by1] = g.box;
    const k = Math.min(wPx / (bx1 - bx0), hPx / (by1 - by0));
    cv.width = Math.max(2, Math.round((bx1 - bx0) * k));
    cv.height = Math.max(2, Math.round((by1 - by0) * k));
    const x = cv.getContext('2d');
    x.setTransform(k, 0, 0, k, -bx0 * k, -by0 * k);
    x.imageSmoothingEnabled = true;
    x.imageSmoothingQuality = 'high';
    const art = img || mark ? panelArt(img, q[1], q[2], smooth, Math.min(q[1], q[2]) * k * 1.4, mark) : null;
    drawSignParts(x, c, g, art, k, isRider(fid), isRider(fid) ? riderOf(c, size) : null);
    return cv;
  }
  function signPic(img, b, smooth, hPx) {
    const cv = document.createElement('canvas');
    cv.className = 'are__cv';
    return drawSign(cv, img, b.sign, b.face, b.rider, smooth, hPx * 1.6, hPx, false);
  }
  function cardPic(cv, img, b) {
    return drawSign(cv, img, b.sign, b.face, b.rider, false, layoutOf(b) === 'col' ? 1000 : 640, layoutOf(b) === 'col' ? 560 : 1000, false);
  }
  function showErr(msg, el = errEl) { el.textContent = msg || ''; el.hidden = !msg; }
  function setInvalid(el, bad) { if (bad) el.setAttribute('aria-invalid', 'true'); else el.removeAttribute('aria-invalid'); }
  function withEmail(body) { if (S.hasEmail && email) body.email = email; return body; }

  function setQuota() {
    if (S.bannersLeft == null) return;
    const n = S.bannersLeft;
    const s = n === 1 ? '' : 's';
    if (S.hasEmail) quotaEl.textContent = n > 0 ? `${n} tr${n === 1 ? 'y' : 'ies'} left today` : 'No tries left today';
    else quotaEl.textContent = n > 0 ? `${n} free tr${n === 1 ? 'y' : 'ies'} · 4 designs each · no sign-up` : `Add your email for ${S.emailBanners} tries a day`;
    if (gateN) gateN.textContent = String(S.emailBanners);
    $$('.abi__fix-left', grid).forEach((el) => { el.textContent = fixesText(); });
  }
  function fixesText() {
    if (S.fixesLeft == null) return '';
    return `${S.fixesLeft} fix${S.fixesLeft === 1 ? '' : 'es'} left today`;
  }

  /* ---------- API ---------- */
  async function api(path, body, timeoutMs = 180000) {
    const opts = {};
    if (body instanceof FormData) { opts.method = 'POST'; opts.body = body; }
    else if (body) { opts.method = 'POST'; opts.headers = { 'Content-Type': 'application/json' }; opts.body = JSON.stringify(body); }
    let timer = 0;
    if (window.AbortController) {
      const ctl = new AbortController();
      opts.signal = ctl.signal;
      timer = setTimeout(() => ctl.abort(), timeoutMs);
    }
    let r;
    try {
      r = await fetch(API + path, opts);
    } catch (e) {
      clearTimeout(timer);
      if (e && e.name === 'AbortError') return { ok: false, error: 'timeout', message: 'This is taking longer than usual. Please try again.' };
      return { ok: false, error: 'network', message: 'Check your connection and try again.' };
    }
    let j = {};
    try { j = await r.json(); } catch (e) { j = {}; }
    clearTimeout(timer);
    if (!j || typeof j !== 'object') j = {};
    if (r.status === 402 && !j.error) j.error = 'need_email';
    if (!r.ok) {
      if (!j.error) j = { ok: false, error: 'server', message: 'Something went wrong on our side. Please try again.' };
      j.ok = false;
    }
    return j;
  }

  /* ---------- Turnstile (same approach as the sticker generator: explicit render, invisible, fresh token per POST) ---------- */
  let tsReady = null;
  let tsWidget = null;
  let tsResolve = null;
  function loadTurnstile() {
    if (!SITEKEY) return Promise.resolve(false);
    if (tsReady) return tsReady;
    tsReady = new Promise((res) => {
      if (window.turnstile && window.turnstile.render) { res(true); return; }
      window.abiTurnstileLoaded = () => res(true);
      const s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=abiTurnstileLoaded';
      s.async = true;
      s.defer = true;
      s.onerror = () => res(false);
      document.head.appendChild(s);
    });
    return tsReady;
  }
  async function botToken() {
    if (!SITEKEY || !(await loadTurnstile()) || !window.turnstile) return '';
    return new Promise((res) => {
      tsResolve = res;
      const take = (t) => { const r = tsResolve; if (r) { tsResolve = null; r(t || ''); } };
      try {
        if (tsWidget === null) {
          tsWidget = window.turnstile.render($('[data-abi-turnstile]'), {
            sitekey: SITEKEY,
            execution: 'execute',
            appearance: 'interaction-only',
            callback: (t) => take(t),
            'error-callback': () => take('')
          });
        } else {
          window.turnstile.reset(tsWidget);
        }
        window.turnstile.execute(tsWidget);
      } catch (e) { take(''); }
      setTimeout(() => { if (tsResolve === res) take(''); }, 45000);
    });
  }

  /* ---------- sign: product, size, piece (sign or rider), rider size, and the side to design ---------- */
  const NOTES = {
    yard: 'A coroplast sign on a steel H-stake. The stake legs slide into the flutes of the sign. We design the sign face and show it on the stake.',
    aframe: 'The sign hangs from a black steel A-frame by zip ties through grommets in its top corners. We design the side you pick and show it on the frame.',
    post: 'The sign hangs from the arm of a white PVC post on hooks through 2 holes near its top. We design the side you pick and show it on the post.',
    frame: 'The sign drops into a black steel frame with stake legs. The frame may cover the outer 3/4 inch, so we design the area inside it.',
    arm: 'The rider sits on top of the post arm.',
    top: 'The rider stands in the clamp on top of the A-frame.',
    below: 'The rider drops into the frame below the sign. The frame may cover its outer 3/4 inch.',
    rider: ' A few big words read best on a rider: SOLD, OPEN HOUSE, a name or a phone number.',
    back: ' You are designing the back. In the real estate sign designer you can also use one design on both sides.',
    long: ' This shape is wider than the AI draws in one piece, so we design the middle and stretch the plain left and right ends to fill it.'
  };
  function chip(label, small, on, click, data) {
    const c = document.createElement('button');
    c.type = 'button';
    c.className = 'abi__chip';
    c.setAttribute('aria-pressed', String(!!on));
    c.textContent = label;
    if (small) { const sm = document.createElement('small'); sm.textContent = small; c.append(' ', sm); }
    Object.keys(data || {}).forEach((k) => { c.dataset[k] = data[k]; });
    c.addEventListener('click', click);
    return c;
  }
  const famList = (f) => SIGNS.filter((x) => x.f === f);
  function fillRow(row, sub, label, items, min) {
    row.innerHTML = '';
    items.forEach((it) => row.appendChild(chip(...it)));
    sub.textContent = label || '';
    sub.hidden = row.hidden = items.length < (min || 2);
  }
  // sign key, face id (front | back | rider-front | rider-back), rider size (riders only; kept while the sign is designed)
  function setSign(key, face, size) {
    const c = signOf(key) || signOf(DEFAULT_SIGN);
    const rs = riderOf(c, size || S.rider);
    let id = String(face || S.face || 'front');
    if (isRider(id) && !rs) id = /back$/.test(id) ? 'back' : 'front';
    if (!faceOf(c, id, rs)) {
      const alt = isRider(id) ? 'rider-front' : 'front';
      id = faceOf(c, alt, rs) ? alt : c.p[0][0];
    }
    S.sign = c.k;
    S.face = id;
    S.rider = rs;
    const r = reqOf(c, S.face, S.rider);
    S.w = r.w;
    S.h = r.h;
    const list = famList(c.f), onRider = isRider(S.face), riders = riderSizes(c);
    famChips.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.fam === c.f)));
    // rows: size, piece (signs with riders), rider size (more than one), then the side to design (2 sided pieces)
    fillRow(row1, sub1, 'Size', list.map((x) => [x.b, x.bs || '', x.k === c.k, () => setSign(x.k, S.face, S.rider), { sign: x.k }]));
    fillRow(row2, sub2, 'What to design', riders.length ? [
      ['Sign', c.b, !onRider, () => setSign(S.sign, S.face === 'rider-back' ? 'back' : 'front', S.rider), { piece: 'sign' }],
      ['Rider', riders.length === 1 ? sizeIn(riders[0]) : 'optional', onRider, () => setSign(S.sign, S.face === 'back' ? 'rider-back' : 'rider-front', S.rider), { piece: 'rider' }]
    ] : []);
    fillRow(row3, sub3, 'Rider size', onRider ? riders.map((s) => [sizeIn(s), '', s === S.rider, () => setSign(S.sign, S.face, s), { rider: s }]) : []);
    const faces = piecesOf(c, S.face, S.rider);
    fillRow(faceRow, sub4, 'Side to design', faces.map((q) => [sideName(q[0]), `${fmtIn(q[1])} x ${fmtIn(q[2])} in`, q[0] === S.face, () => setSign(S.sign, q[0], S.rider), { face: q[0] }]));
    try { drawSign(shapeCv, null, c.k, S.face, S.rider, false, 300, 440, true); shapeCv.hidden = false; } catch (e) { shapeCv.hidden = true; }
    shapeLabel.textContent = `${c.n}${onRider ? ` · ${sizeIn(S.rider)} rider` : ''}${faces.length > 1 ? ` · ${sideName(S.face)}` : ''} · design area ${fmtIn(r.pw)} x ${fmtIn(r.ph)} in`;
    const ar = r.pw / r.ph;
    sizeNote.textContent = (onRider ? (NOTES[c.rp] || NOTES.below) + NOTES.rider : NOTES[c.f] || NOTES.yard) + (/back$/.test(S.face) ? NOTES.back : '') + (ar > 3.05 || ar < 1 / 3.05 ? NOTES.long : '');
    showErr('', sizeErr);
  }
  famChips.forEach((b) => {
    const list = famList(b.dataset.fam);
    b.hidden = !list.length;
    b.addEventListener('click', () => {
      const cur = signOf(S.sign);
      if (!list.length || (cur && cur.f === b.dataset.fam)) return;
      const same = cur && list.find((x) => x.b === cur.b);
      setSign((same || list.find((x) => x.d) || list[0]).k, S.face, S.rider);
    });
  });

  /* ---------- real estate ideas: a starting headline, style and style notes (all editable) ---------- */
  const IDEAS = {
    'for-sale': { h: 'FOR SALE', style: 'bold', notes: 'Real estate for sale sign, big clear words that read from the street', sub: 'e.g. Your name · Your brokerage' },
    'open-house': { h: 'OPEN HOUSE', style: 'bold', notes: 'Real estate open house sign with an arrow, easy to read from a passing car', sub: 'e.g. Sunday 1-4 PM' },
    sold: { h: 'SOLD', style: 'bold', notes: 'Real estate sold sign, simple and confident', sub: 'e.g. Your name · Your brokerage' },
    'coming-soon': { h: 'COMING SOON', style: 'clean', notes: 'Real estate coming soon sign, modern and clean', sub: 'e.g. 4 bed · 3 bath' },
    'price-reduced': { h: 'PRICE REDUCED', style: 'bold', notes: 'Real estate price reduced sign, bold and easy to read', sub: 'e.g. Call for a showing' },
    luxury: { h: 'FOR SALE', style: 'elegant', notes: 'Luxury home listing sign, black and gold, lots of space, refined letters', sub: 'e.g. Your name · Your brokerage' },
    lease: { h: 'FOR LEASE', style: 'clean', notes: 'Commercial property for lease sign, clean and professional', sub: 'e.g. 2,400 sq ft retail space' }
  };
  const ideaChips = $$('[data-are-ideas] .abi__chip');
  let styleTouched = false;
  styleBtns.forEach((b) => b.addEventListener('click', () => { styleTouched = true; }));
  function setIdea(id) {
    const it = IDEAS[id];
    if (!it) return;
    const prev = IDEAS[S.idea];
    const h = lineIns.headline;
    if (!clean(h.value) || (prev && clean(h.value) === prev.h)) { h.value = it.h; syncCount('headline', h); setInvalid(h, false); showErr('', headErr); }
    if (!clean(notesIn.value) || (prev && clean(notesIn.value) === prev.notes)) { notesIn.value = it.notes; syncCount('notes', notesIn); }
    lineIns.subline.placeholder = it.sub;
    if (!styleTouched) setStyle(it.style);
    S.idea = id;
    ideaChips.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.idea === id)));
    track('ardor_realestate_ai_idea', { idea: id });
  }
  ideaChips.forEach((b) => b.addEventListener('click', () => setIdea(b.dataset.idea)));
  /* ---------- logo: any image -> PNG (max 1536 px long side) in the browser ---------- */
  const LOGO_TYPES = /^image\/(png|jpeg|jpg|pjpeg|webp|svg\+xml|gif)$/i;
  const LOGO_EXT = /\.(png|jpe?g|webp|svg|gif)$/i;
  function loadImg(src) {
    return new Promise((res, rej) => {
      const im = new Image();
      im.decoding = 'async';
      im.onload = () => res(im);
      im.onerror = () => rej(new Error('image'));
      im.src = src;
    });
  }
  function canvasBlob(img, w, h, type = 'image/png') {
    const c = document.createElement('canvas');
    c.width = w;
    c.height = h;
    const ctx = c.getContext('2d');
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(img, 0, 0, w, h);
    return new Promise((res, rej) => c.toBlob((b) => (b ? res(b) : rej(new Error('toBlob'))), type));
  }
  function thumbData(img, w, h) {
    const s = Math.min(1, 160 / Math.max(w, h));
    const c = document.createElement('canvas');
    c.width = Math.max(1, Math.round(w * s));
    c.height = Math.max(1, Math.round(h * s));
    c.getContext('2d').drawImage(img, 0, 0, c.width, c.height);
    try { return c.toDataURL('image/png'); } catch (e) { return ''; }
  }
  async function svgSource(file) {
    const txt = await file.text();
    const doc = new DOMParser().parseFromString(txt, 'image/svg+xml');
    const svg = doc.documentElement;
    if (!svg || svg.nodeName.toLowerCase() !== 'svg' || doc.getElementsByTagName('parsererror').length) throw new Error('svg');
    const dim = (a) => { const v = svg.getAttribute(a) || ''; return /%/.test(v) ? NaN : parseFloat(v); };
    let vw = dim('width');
    let vh = dim('height');
    const vb = (svg.getAttribute('viewBox') || '').trim().split(/[\s,]+/).map(Number);
    const hasVb = vb.length === 4 && vb[2] > 0 && vb[3] > 0;
    if (hasVb && !(vw > 0 && vh > 0)) { vw = vb[2]; vh = vb[3]; }
    if (!(vw > 0 && vh > 0)) { vw = 1024; vh = 1024; }
    if (!hasVb) svg.setAttribute('viewBox', `0 0 ${vw} ${vh}`);
    const s = MAX_LOGO_PX / Math.max(vw, vh); // vector: always render at the full 1536 px long side
    const w = Math.max(1, Math.round(vw * s));
    const h = Math.max(1, Math.round(vh * s));
    svg.setAttribute('width', String(w));
    svg.setAttribute('height', String(h));
    const src = URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(svg)], { type: 'image/svg+xml' }));
    return { src, w, h };
  }
  async function toPng(file) {
    const isSvg = /svg/i.test(file.type) || /\.svg$/i.test(file.name);
    let src;
    let w;
    let h;
    if (isSvg) ({ src, w, h } = await svgSource(file));
    else src = URL.createObjectURL(file);
    try {
      const img = await loadImg(src);
      if (!isSvg) {
        const nw = img.naturalWidth;
        const nh = img.naturalHeight;
        if (!nw || !nh) throw new Error('size');
        const s = Math.min(1, MAX_LOGO_PX / Math.max(nw, nh));
        w = Math.max(1, Math.round(nw * s));
        h = Math.max(1, Math.round(nh * s));
      }
      let blob = await canvasBlob(img, w, h);
      for (let i = 0; i < 4 && blob.size > MAX_LOGO_BYTES; i++) {
        w = Math.max(1, Math.round(w * 0.75));
        h = Math.max(1, Math.round(h * 0.75));
        blob = await canvasBlob(img, w, h);
      }
      if (blob.size > MAX_LOGO_BYTES) throw new Error('big');
      return { blob, w, h, thumbData: thumbData(img, w, h) };
    } finally {
      URL.revokeObjectURL(src);
    }
  }
  function setLogo(L) {
    if (S.logo && S.logo.thumb && S.logo.thumb.indexOf('blob:') === 0) URL.revokeObjectURL(S.logo.thumb);
    S.logo = L;
    if (L) {
      logoImg.src = L.thumb || L.thumbData || '';
      logoName.textContent = L.name || 'Your logo';
      logoInfo.textContent = 'Added to every design';
    }
    logoRow.hidden = !L;
    drop.hidden = !!L;
  }
  async function takeLogo(file) {
    showErr('', logoErr);
    if (!(LOGO_TYPES.test(file.type || '') || LOGO_EXT.test(file.name || ''))) { showErr('Please choose a PNG, JPG, SVG, WEBP or GIF file.', logoErr); return; }
    if (file.size > MAX_SOURCE_BYTES) { showErr('That file is too big. Please use one under 30 MB.', logoErr); return; }
    drop.classList.add('is-busy');
    try {
      const out = await toPng(file);
      setLogo({ blob: out.blob, w: out.w, h: out.h, name: file.name, id: null, thumb: URL.createObjectURL(out.blob), thumbData: out.thumbData });
      track('ardor_realestate_ai_logo', {});
    } catch (e) {
      showErr("We couldn't read that file. Try saving your logo as a PNG or JPG.", logoErr);
    }
    drop.classList.remove('is-busy');
  }
  fileIn.addEventListener('change', () => {
    const f = fileIn.files && fileIn.files[0];
    if (f) takeLogo(f);
    fileIn.value = '';
  });
  ['dragenter', 'dragover'].forEach((t) => drop.addEventListener(t, () => drop.classList.add('is-over')));
  ['dragleave', 'drop'].forEach((t) => drop.addEventListener(t, () => drop.classList.remove('is-over')));
  $('[data-abi-logo-remove]').addEventListener('click', () => {
    setLogo(null);
    showErr('', logoErr);
    fileIn.focus();
  });
  async function uploadLogo() {
    const L = S.logo;
    if (!L) return '';
    if (L.id) return L.id;
    if (!L.blob) throw { message: 'Please add your logo again.' };
    const fd = new FormData();
    fd.append('file', L.blob, 'logo.png');
    fd.append('visitor', visitor);
    const j = await api('/api/banner/logo', fd, 60000);
    if (!j.ok || !j.logoId) throw j;
    L.id = j.logoId;
    return j.logoId;
  }

  /* ---------- wording + style ---------- */
  function syncCount(key, el) {
    const c = $(`[data-abi-count="${key}"]`);
    if (!c) return;
    const n = el.value.length;
    c.textContent = `${n}/${LIMITS[key]}`;
    c.classList.toggle('is-near', n >= LIMITS[key] - 5);
  }
  Object.keys(lineIns).forEach((k) => {
    lineIns[k].addEventListener('input', () => {
      syncCount(k, lineIns[k]);
      if (k === 'headline' && clean(lineIns[k].value)) { setInvalid(lineIns[k], false); showErr('', headErr); }
      showErr('');
    });
  });
  notesIn.addEventListener('input', () => syncCount('notes', notesIn));

  function setStyle(st) {
    S.style = STYLES[st] ? st : 'bold';
    styleBtns.forEach((b) => {
      const on = b.dataset.style === S.style;
      b.setAttribute('aria-checked', String(on));
      b.tabIndex = on ? 0 : -1;
    });
  }
  styleBtns.forEach((b) => {
    b.addEventListener('click', () => setStyle(b.dataset.style));
    b.addEventListener('keydown', (e) => {
      if (!['ArrowRight', 'ArrowLeft', 'ArrowDown', 'ArrowUp'].includes(e.key)) return;
      e.preventDefault();
      const i = styleBtns.indexOf(b);
      const n = styleBtns[(i + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1) + styleBtns.length) % styleBtns.length];
      setStyle(n.dataset.style);
      n.focus();
    });
  });

  function readForm(show) {
    const sc = signOf(S.sign);
    let first = null;
    if (!sc || !faceOf(sc, S.face, S.rider) || !validFt(S.w) || !validFt(S.h)) {
      if (show) showErr('Pick your sign and its size.', sizeErr);
      first = famChips[0] || null;
    }
    const headline = clean(lineIns.headline.value).slice(0, LIMITS.headline);
    setInvalid(lineIns.headline, !headline);
    if (!headline) {
      if (show) showErr('Type the main words for your sign.', headErr);
      first = first || lineIns.headline;
    }
    if (first) {
      if (show) { first.focus({ preventScroll: true }); first.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      return null;
    }
    const lines = { headline };
    const sub = clean(lineIns.subline.value).slice(0, LIMITS.subline);
    const det = clean(lineIns.details.value).slice(0, LIMITS.details);
    if (sub) lines.subline = sub;
    if (det) lines.details = det;
    return { w: S.w, h: S.h, sign: S.sign, face: S.face, rider: isRider(S.face) ? S.rider : null, idea: S.idea || '', style: S.style, notes: clean(notesIn.value).slice(0, LIMITS.notes), lines, hasLogo: !!S.logo };
  }

  /* ---------- busy states ---------- */
  function setBusyUi(on) {
    goBtn.disabled = on || S.off;
    goLabel.textContent = on ? 'Designing…' : 'Design my sign';
    againBtn.disabled = on;
    editBtn.disabled = on;
    $$('button, input', grid).forEach((el) => { el.disabled = on; });
  }
  let genTimer = 0;
  function placeholder(ar) {
    const c = document.createElement('div');
    c.className = 'abi__card is-loading';
    c.setAttribute('aria-hidden', 'true');
    c.innerHTML = `<div class="abi__frame" style="--ar:${ar}"><span class="abi__skel" style="--art:${clampAr(ar)}"><i></i><i></i><i></i></span></div><div class="abi__card-actions"><span class="abi__skel-btn"></span><span class="abi__skel-btn"></span></div>`;
    return c;
  }
  function startGenLoading(v) {
    S.busy = true;
    setBusyUi(true);
    results.hidden = false;
    loading.hidden = false;
    againRow.hidden = true;
    fineEl.hidden = true;
    echo.textContent = v.lines.headline;
    metaEl.textContent = `${signLabel(v.sign, v.face, v.rider)} · ${STYLES[v.style]}`;
    const ar = frameArOf(v.sign, v.face);
    grid.dataset.shape = 'sign';
    grid.setAttribute('aria-busy', 'true');
    grid.innerHTML = '';
    for (let i = 0; i < 4; i++) grid.appendChild(placeholder(ar));
    const steps = GEN_STEPS.filter((m) => !m[3] || (m[3] === 'logo' && v.hasLogo));
    const t0 = Date.now();
    let last = -1;
    const tick = () => {
      const t = (Date.now() - t0) / 1000;
      bar.style.width = `${Math.min(95, 100 * (1 - Math.exp(-t / 36)))}%`;
      let k = 0;
      steps.forEach((m, i) => { if (t >= m[0]) k = i; });
      if (k === last) return;
      last = k;
      statusEl.textContent = steps[k][1];
      stepEls.forEach((li, i) => {
        li.classList.toggle('is-done', i < steps[k][2]);
        li.classList.toggle('is-on', i === steps[k][2]);
      });
    };
    clearInterval(genTimer);
    tick();
    genTimer = setInterval(tick, 250);
  }
  function stopGenLoading() {
    clearInterval(genTimer);
    S.busy = false;
    setBusyUi(false);
    loading.hidden = true;
    bar.style.width = '0';
    againRow.hidden = false;
    fineEl.hidden = false;
    grid.removeAttribute('aria-busy');
  }
  function cardBusy(card, title, sub, slow) {
    const o = $('.abi__busy', card);
    const fill = $('.abi__busy-bar i', card);
    $('.abi__busy-t', card).textContent = title;
    $('.abi__busy-s', card).textContent = sub;
    o.hidden = false;
    card.classList.add('is-busy');
    const t0 = Date.now();
    const tm = setInterval(() => { fill.style.width = `${Math.min(95, 100 * (1 - Math.exp(-(Date.now() - t0) / 1000 / slow)))}%`; }, 250);
    return () => { clearInterval(tm); o.hidden = true; card.classList.remove('is-busy'); fill.style.width = '0'; };
  }
  function cardErr(card, msg) { const el = card && $('.abi__cerr', card); if (el) showErr(msg, el); }
  const findCard = (id) => grid.querySelector(`.abi__card[data-id="${window.CSS && CSS.escape ? CSS.escape(id) : id}"]`);

  /* ---------- busy edges (same check as the banner builder, ardor-banner-layers.js) ---------- */
  const EDGE_BUSY = 2.5;
  // How streaky a design's stretched ends will look. Looks at the outer 2% of each edge that gets stretched,
  // sampled about 96 steps along the edge, and measures change in both directions: plain colors, smooth
  // gradients and stripes that already run straight off the edge score near 0; photos, busy textures and
  // text or shapes cut by the edge score high. Returns { a, b, score, busy } (a = left/top, b = right/bottom).
  function edgeBusy(img, wide) {
    var iw = img.naturalWidth || img.width, ih = img.naturalHeight || img.height;
    if (!iw || !ih) return null;
    var L = wide ? ih : iw, st = Math.max(1, L / 96);
    var n = Math.max(16, Math.round(L / st)), d = Math.max(4, Math.round((wide ? iw : ih) * 0.02 / st)), depth = d * st;
    var cw = wide ? d : n, ch = wide ? n : d, res = [];
    for (var s = 0; s < 2; s++) {
      var c = document.createElement('canvas'); c.width = cw; c.height = ch;
      var x = c.getContext('2d', { willReadFrequently: true });
      x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
      if (wide) x.drawImage(img, s ? iw - depth : 0, 0, depth, ih, 0, 0, cw, ch);
      else x.drawImage(img, 0, s ? ih - depth : 0, iw, depth, 0, 0, cw, ch);
      var p = x.getImageData(0, 0, cw, ch).data;
      // per block along the edge (8 blocks): mean change along the edge and across it, max over R, G, B
      var B = 8, al = new Float64Array(B), ac = new Float64Array(B), na = new Float64Array(B), nc = new Float64Array(B);
      for (var yy = 0; yy < ch; yy++) for (var xx = 0; xx < cw; xx++) {
        var i = (yy * cw + xx) * 4, along = wide ? yy : xx, blk = Math.min(B - 1, Math.floor(along * B / n));
        if (xx + 1 < cw) {
          var dx = Math.max(Math.abs(p[i] - p[i + 4]), Math.abs(p[i + 1] - p[i + 5]), Math.abs(p[i + 2] - p[i + 6]));
          if (wide) { ac[blk] += dx; nc[blk]++; } else { al[blk] += dx; na[blk]++; }
        }
        if (yy + 1 < ch) {
          var j = i + cw * 4, dy = Math.max(Math.abs(p[i] - p[j]), Math.abs(p[i + 1] - p[j + 1]), Math.abs(p[i + 2] - p[j + 2]));
          if (wide) { al[blk] += dy; na[blk]++; } else { ac[blk] += dy; nc[blk]++; }
        }
      }
      var sum = 0, top = 0;
      for (var k = 0; k < B; k++) {
        var v = Math.sqrt((na[k] ? al[k] / na[k] : 0) * (nc[k] ? ac[k] / nc[k] : 0));
        sum += v; if (v > top) top = v;
      }
      res.push(Math.max(sum / B, top * 0.5));
    }
    var score = Math.max(res[0], res[1]);
    return { a: res[0], b: res[1], score: score, busy: score > EDGE_BUSY };
  }


  /* ---------- end previews (same drawing as the banner builder's extend(), ardor-banner-layers.js) ---------- */
  // Draws the design at the banner's real shape with its ends filled, stretched (as the builder does by default)
  // or smooth (&ends=smooth), so the customer can pick before the print version is made. size = preview short side.
  function mkC(w, h) { const c = document.createElement('canvas'); c.width = Math.max(1, Math.round(w)); c.height = Math.max(1, Math.round(h)); return c; }
  function composeEnds(img, B, smooth, size) {
    // sign faces: extend the sides when the face is wider than the design (any aspect), else the top and bottom
    const nw = img.naturalWidth || img.width, nh = img.naturalHeight || img.height, wide = B > nw / nh;
    const k = Math.min(1, size / (wide ? nh : nw));
    const src = mkC(nw * k, nh * k), sx0 = src.getContext('2d');
    sx0.imageSmoothingEnabled = true; sx0.imageSmoothingQuality = 'high'; sx0.drawImage(img, 0, 0, src.width, src.height);
    const iw0 = src.width, ih0 = src.height;
    let cw, ch;
    if (wide) { ch = ih0; cw = Math.round(ih0 * B); } else { cw = iw0; ch = Math.round(iw0 / B); }
    const iw = wide ? Math.round(iw0 * ch / ih0) : cw, ih = wide ? ch : Math.round(ih0 * cw / iw0);
    const ox = wide ? Math.round((cw - iw) / 2) : 0, oy = wide ? 0 : Math.round((ch - ih) / 2);
    const cv = mkC(cw, ch), x = cv.getContext('2d');
    x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'high';
    const A = wide ? ['l', 0, 0, ox, ch, 'r', ox + iw, 0, cw - ox - iw, ch] : ['t', 0, 0, cw, oy, 'b', 0, oy + ih, cw, ch - oy - ih];
    for (let q = 0; q < 10; q += 5) (smooth ? soften : side)(x, src, iw0, ih0, A[q], A[q + 1], A[q + 2], A[q + 3], A[q + 4]);
    x.drawImage(src, ox, oy, iw, ih);
    if (smooth) {
      const f = Math.max(2, Math.round((wide ? iw : ih) * 0.05));
      if (wide) { soften(x, src, iw0, ih0, 'l', ox, 0, f, ch, 1); soften(x, src, iw0, ih0, 'r', ox + iw - f, 0, f, ch, 1); }
      else { soften(x, src, iw0, ih0, 't', 0, oy, cw, f, 1); soften(x, src, iw0, ih0, 'b', 0, oy + ih - f, cw, f, 1); }
    }
    return cv;
  }
  // soft fill for one side: the outer 6% of the design averaged into 6 steps along the edge, then
  // stretched smoothly over the side. feather = 1 draws it over the design's own edge, fading out inward.
  function soften(x, img, iw0, ih0, where, dx, dy, dw, dh, feather) {
    if (dw < 1 || dh < 1) return;
    var horiz = where === 'l' || where === 'r', band = Math.max(1, Math.round((horiz ? iw0 : ih0) * 0.06));
    var mid = horiz ? mkC(1, 64) : mkC(64, 1), mx = mid.getContext('2d');
    mx.imageSmoothingEnabled = true; mx.imageSmoothingQuality = 'high';
    if (where === 'l') mx.drawImage(img, 0, 0, band, ih0, 0, 0, 1, 64);
    if (where === 'r') mx.drawImage(img, iw0 - band, 0, band, ih0, 0, 0, 1, 64);
    if (where === 't') mx.drawImage(img, 0, 0, iw0, band, 0, 0, 64, 1);
    if (where === 'b') mx.drawImage(img, 0, ih0 - band, iw0, band, 0, 0, 64, 1);
    var small = horiz ? mkC(1, 6) : mkC(6, 1), smx = small.getContext('2d');
    smx.imageSmoothingEnabled = true; smx.imageSmoothingQuality = 'high';
    smx.drawImage(mid, 0, 0, small.width, small.height);
    var soft = mkC(dw, dh), so = soft.getContext('2d');
    so.imageSmoothingEnabled = true; so.imageSmoothingQuality = 'high';
    so.drawImage(small, 0, 0, dw, dh);
    if (feather) {
      var g = where === 'l' ? so.createLinearGradient(0, 0, dw, 0) : where === 'r' ? so.createLinearGradient(dw, 0, 0, 0)
        : where === 't' ? so.createLinearGradient(0, 0, 0, dh) : so.createLinearGradient(0, dh, 0, 0);
      g.addColorStop(0, 'rgba(0,0,0,1)'); g.addColorStop(1, 'rgba(0,0,0,0)');
      so.globalCompositeOperation = 'destination-in'; so.fillStyle = g; so.fillRect(0, 0, dw, dh);
    }
    x.drawImage(soft, dx, dy);
  }
  function side(x, img, iw0, ih0, where, dx, dy, dw, dh) {
    if (dw < 1 || dh < 1) return;
    var horiz = where === 'l' || where === 'r', n = Math.max(1, Math.min(4, horiz ? iw0 : ih0));
    var line = horiz ? mkC(1, dh) : mkC(dw, 1), lx = line.getContext('2d');
    lx.imageSmoothingEnabled = true; lx.imageSmoothingQuality = 'high';
    if (where === 'l') lx.drawImage(img, 0, 0, n, ih0, 0, 0, 1, dh);
    if (where === 'r') lx.drawImage(img, iw0 - n, 0, n, ih0, 0, 0, 1, dh);
    if (where === 't') lx.drawImage(img, 0, 0, iw0, n, 0, 0, dw, 1);
    if (where === 'b') lx.drawImage(img, 0, ih0 - n, iw0, n, 0, 0, dw, 1);
    var sharp = mkC(dw, dh), sx = sharp.getContext('2d');
    sx.imageSmoothingEnabled = false;
    sx.drawImage(line, 0, 0, dw, dh);
    var len = horiz ? dh : dw, k = Math.max(2, Math.round(len / 40));
    var small = horiz ? mkC(1, Math.max(2, Math.round(dh / k))) : mkC(Math.max(2, Math.round(dw / k)), 1), smx = small.getContext('2d');
    smx.imageSmoothingEnabled = true; smx.imageSmoothingQuality = 'high';
    smx.drawImage(line, 0, 0, small.width, small.height);
    var soft = mkC(dw, dh), so = soft.getContext('2d');
    so.imageSmoothingEnabled = true; so.imageSmoothingQuality = 'high';
    so.drawImage(small, 0, 0, dw, dh);
    var fade = Math.max(1, Math.min(horiz ? dw : dh, len * 0.3)), g;
    if (where === 'l') g = so.createLinearGradient(dw, 0, dw - fade, 0);
    else if (where === 'r') g = so.createLinearGradient(0, 0, fade, 0);
    else if (where === 't') g = so.createLinearGradient(0, dh, 0, dh - fade);
    else g = so.createLinearGradient(0, 0, 0, fade);
    g.addColorStop(0, 'rgba(0,0,0,0)'); g.addColorStop(1, 'rgba(0,0,0,1)');
    so.globalCompositeOperation = 'destination-in'; so.fillStyle = g; so.fillRect(0, 0, dw, dh);
    sx.drawImage(soft, 0, 0);
    x.drawImage(sharp, dx, dy);
  }

  /* ---------- "How should we fill the ends?" (busy designs on banners wider than 3:1 or taller than 1:3) ---------- */
  function askEnds(card, img) {
    if (S.busy || !S.batch) return;
    let panel = $('.abi__ends', card);
    if (panel) { panel.hidden = false; card.classList.add('is-asking'); $('[data-ends="smooth"]', panel).focus(); return; }
    const b = S.batch, real = b.w / b.h, wide = real > img.w / img.h;
    const k = `abi-ends-${++uid}`;
    panel = document.createElement('div');
    panel.className = 'abi__ends';
    panel.setAttribute('role', 'group');
    panel.setAttribute('aria-labelledby', k);
    panel.innerHTML = `
      <p class="abi__ends-t" id="${k}"><b>How should we fill the ends?</b></p>
      <div class="abi__ends-opts">
        <button type="button" class="abi__endopt is-rec" data-ends="smooth"><span class="abi__endpic"></span><b>Smooth ends</b><small>A soft blend of the edge colors. Recommended</small></button>
        <button type="button" class="abi__endopt" data-ends="stretch"><span class="abi__endpic"></span><b>Stretched ends</b><small>The edges stretched out as they are</small></button>
      </div>
      <button type="button" class="abi__ends-back">Pick another design</button>`;
    $('.abi__ends-t', panel).append(` Your ${signShort(b)} is ${wide ? 'wider' : 'taller'} than this design, so we fill the ${wide ? 'left and right' : 'top and bottom'} ends from its edges. Its edges are busy, so stretched ends may look streaky.`);
    const im = $('.abi__img', card);
    [['smooth', true], ['stretch', false]].forEach(([key, smooth]) => {
      try { $(`[data-ends="${key}"] .abi__endpic`, panel).appendChild(signPic(im, b, smooth, 260)); } catch (e) { /* preview not drawable: the labels still explain it */ }
      $(`[data-ends="${key}"]`, panel).addEventListener('click', () => { closeEnds(card); track('ardor_realestate_ai_ends', { ends: key }); useDesign(img.id, key); });
    });
    $('.abi__ends-back', panel).addEventListener('click', () => { closeEnds(card); $('[data-act="use"]', card).focus({ preventScroll: true }); });
    $('.abi__card-actions', card).before(panel);
    card.classList.add('is-asking');
    $('[data-ends="smooth"]', panel).focus({ preventScroll: true });
    panel.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
  function closeEnds(card) { const p = $('.abi__ends', card); if (p) p.hidden = true; card.classList.remove('is-asking'); }

  /* ---------- results ---------- */
  let uid = 0;
  function cardFor(img, i, fixed) {
    const b = S.batch;
    const real = b.w / b.h;
    const art = img.w > 0 && img.h > 0 ? img.w / img.h : clampAr(real);
    const ext = Math.abs(real - art) / art > 0.03;
    const flagged = !!(img.check && img.check.ok === false);
    const n = i + 1;
    const k = `abi-fix-${++uid}`;
    const card = document.createElement('article');
    card.className = `abi__card${flagged ? ' is-flagged' : ''}`;
    card.setAttribute('role', 'listitem');
    card.setAttribute('aria-label', `Design ${n}`);
    card.dataset.id = img.id;
    card.innerHTML = `
      <div class="abi__frame are__frame are__frame--${layoutOf(b)}${isRider(b.face) ? ' are__frame--rider' : ''}" style="--ar:${frameArOf(b.sign, b.face)}">
        <div class="are__mock"><canvas class="are__cv" aria-hidden="true"></canvas></div>
        <div class="are__flat"><img class="abi__img" alt="" decoding="async"><small class="are__cap">${piecesOf(signOf(b.sign), b.face, b.rider).length > 1 || isRider(b.face) ? faceName(b.face) : 'Flat'} artwork</small></div>
        ${fixed ? '<span class="abi__badge">Fixed</span>' : ''}
      </div>
      ${ext ? '<p class="abi__extnote"></p>' : ''}
      ${flagged ? '<p class="abi__flag"><svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3.5 2.5 20h19L12 3.5zM12 10v4.5M12 17.5v.01"/></svg><span>This one may have a spelling or logo mistake — use Fix a word or pick another.</span></p>' : ''}
      <p class="abi__cerr" role="alert" hidden></p>
      <div class="abi__card-actions">
        <button type="button" class="ws-btn abi__use" data-act="use">Use this design<span class="abi__vh"> (design ${n})</span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></button>
        <button type="button" class="ws-btn ws-btn--ghost abi__fixbtn" data-act="fix" aria-expanded="false" aria-controls="${k}">Fix a word<span class="abi__vh"> (design ${n})</span></button>
      </div>
      <form class="abi__fix" id="${k}" hidden novalidate>
        <label class="abi__flabel" for="${k}-in">What should we fix?</label>
        <div class="abi__fix-row">
          <input id="${k}-in" class="abi__input" type="text" maxlength="${LIMITS.fix}" autocomplete="off">
          <button type="submit" class="ws-btn ws-btn--ghost">Fix it</button>
        </div>
        <small class="abi__fix-left"></small>
      </form>
      <div class="abi__busy" hidden><span class="abi__spin" aria-hidden="true"></span><b class="abi__busy-t"></b><small class="abi__busy-s"></small><span class="abi__busy-bar" aria-hidden="true"><i></i></span></div>`;
    const im = $('.abi__img', card);
    im.alt = `Real estate ${isRider(b.face) ? 'rider' : 'sign'} design ${n}: ${b.lines.headline}`;
    im.addEventListener('load', () => {
      card.classList.add('is-in');
      try { cardPic($('.are__cv', card), im, b); } catch (e) { card.classList.add('no-mock'); }
      if (!ext) return;
      let eb = null;
      try { eb = edgeBusy(im, real > art); } catch (e) { /* image not readable: keep the plain note */ }
      if (!eb || !eb.busy) return;
      card.dataset.busy = '1';
      const note = $('.abi__extnote', card);
      note.classList.add('is-warn');
      note.textContent = `Busy edges: the stretched ${real > art ? 'left and right' : 'top and bottom'} ends of this design may look streaky. When you use it, you can pick smooth ends instead.`;
    });
    im.addEventListener('error', () => card.classList.add('is-broken'));
    im.crossOrigin = 'anonymous'; // the sign picture and the busy-edge check read the pixels (the worker sends CORS *)
    im.src = img.url;
    if (ext) $('.abi__extnote', card).textContent = `We stretch the plain ${real > art ? 'left and right' : 'top and bottom'} ends to fill your ${signShort(b)}.`;
    const fixForm = $('.abi__fix', card);
    const fixIn = $('input', fixForm);
    const fixBtn = $('[data-act="fix"]', card);
    fixIn.placeholder = 'e.g. Change "Snohomsh" to "Snohomish"';
    $('.abi__fix-left', card).textContent = fixesText();
    $('[data-act="use"]', card).addEventListener('click', () => (card.dataset.busy ? askEnds(card, img) : useDesign(img.id)));
    fixBtn.addEventListener('click', () => {
      const open = fixForm.hidden;
      fixForm.hidden = !open;
      fixBtn.setAttribute('aria-expanded', String(open));
      if (!open) return;
      const wrong = img.check && Array.isArray(img.check.wrong) ? img.check.wrong.find((x) => x && x.expected && x.seen) : null;
      if (wrong && !fixIn.value) fixIn.value = `Change "${wrong.seen}" to "${wrong.expected}"`;
      fixIn.focus();
    });
    fixForm.addEventListener('submit', (e) => { e.preventDefault(); fixDesign(img.id, fixIn.value); });
    if (S.busy) $$('button, input', card).forEach((el) => { el.disabled = true; });
    return card;
  }
  function renderResults() {
    const b = S.batch;
    if (!b || !b.images || !b.images.length) { results.hidden = true; return; }
    results.hidden = false;
    loading.hidden = true;
    againRow.hidden = false;
    fineEl.hidden = false;
    echo.textContent = b.lines.headline;
    metaEl.textContent = `${signLabel(b.sign, b.face, b.rider)} · ${STYLES[b.style] || ''}`;
    grid.dataset.shape = 'sign';
    grid.innerHTML = '';
    b.images.forEach((img, i) => grid.appendChild(cardFor(img, i, !!img.fixedFrom)));
    const bad = b.images.filter((x) => x.check && x.check.ok === false).length;
    if (bad && bad === b.images.length) statusEl.textContent = 'These may have a mistake. Use Fix a word or make another set.';
    else statusEl.textContent = b.images.length > 1 ? `${b.images.length} designs ready. Pick your favorite.` : 'Your design is ready.';
  }
  function remember() {
    const L = S.logo;
    sset(LAST_KEY, {
      at: Date.now(),
      batch: S.batch,
      form: { sign: S.sign, face: S.face, rider: S.rider, idea: S.idea || '', style: S.style, notes: notesIn.value, headline: lineIns.headline.value, subline: lineIns.subline.value, details: lineIns.details.value },
      logo: L && L.id ? { id: L.id, name: L.name, w: L.w, h: L.h, thumbData: L.thumbData } : null
    });
  }

  /* ---------- generate / fix / final ---------- */
  async function generate() {
    if (S.busy || S.off) return;
    const v = readForm(true);
    if (!v) return;
    if (!S.hasEmail && S.bannersLeft === 0) { S.pending = { kind: 'generate', run: generate }; openGate(); return; }
    showErr('');
    const prev = S.batch;
    startGenLoading(v);
    results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    let logoId = '';
    if (v.hasLogo) {
      try {
        logoId = await uploadLogo();
      } catch (j) {
        stopGenLoading();
        S.batch = prev;
        renderResults();
        showErr((j && j.message) || "We couldn't upload your logo. Try another file, or remove it and try again.");
        form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
    }
    const token = await botToken();
    const body = withEmail({ visitor, token, product: 'banner', widthFt: v.w, heightFt: v.h, style: v.style, styleNotes: v.notes, lines: v.lines });
    if (logoId) body.logoId = logoId;
    const j = await api('/api/banner/generate', body);
    stopGenLoading();
    if (j.bannersLeft != null) S.bannersLeft = j.bannersLeft;
    if (j.fixesLeft != null) S.fixesLeft = j.fixesLeft;
    if (!j.ok || !Array.isArray(j.images) || !j.images.length) {
      S.batch = prev;
      renderResults();
      if (j.error === 'need_email') {
        S.bannersLeft = 0;
        setQuota();
        S.pending = { kind: 'generate', run: generate };
        openGate();
        return;
      }
      showErr(j.message || "We couldn't make your designs this time. Please try again.");
      setQuota();
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if ('hasEmail' in j) S.hasEmail = !!j.hasEmail;
    S.batch = {
      batchId: j.batchId || '', aspect: j.aspect, clamped: !!j.clamped,
      w: v.w, h: v.h, sign: v.sign, face: v.face, rider: v.rider, idea: v.idea, style: v.style, notes: v.notes, lines: v.lines,
      logoId: logoId || null, images: j.images.slice(0, 8)
    };
    setQuota();
    renderResults();
    remember();
    h2.focus({ preventScroll: true });
    track('ardor_realestate_ai_generated', { style: v.style, sign: v.sign, face: v.face, rider: v.rider || '', idea: v.idea || '', logo: !!logoId, shown: j.images.length });
  }

  async function fixDesign(id, text) {
    if (S.busy) return;
    const card = findCard(id);
    if (!card) return;
    const input = $('.abi__fix input', card);
    const fix = clean(text).slice(0, LIMITS.fix);
    if (fix.length < 2) { cardErr(card, 'Tell us what to fix, like: Change "Snohomsh" to "Snohomish".'); input.focus(); return; }
    if (!S.hasEmail && S.fixesLeft === 0) { S.pending = { kind: 'fix', run: () => fixDesign(id, fix) }; openGate(); return; }
    cardErr(card, '');
    S.busy = true;
    setBusyUi(true);
    const done = cardBusy(card, 'Fixing it…', 'Redoing just that part', 14);
    statusEl.textContent = 'Fixing your design…';
    const token = await botToken();
    const j = await api('/api/banner/fix', withEmail({ visitor, token, imageId: id, fix }));
    done();
    S.busy = false;
    setBusyUi(false);
    if (j.fixesLeft != null) S.fixesLeft = j.fixesLeft;
    if (!j.ok || !Array.isArray(j.images) || !j.images.length) {
      setQuota();
      statusEl.textContent = '';
      if (j.error === 'need_email') { S.fixesLeft = 0; S.pending = { kind: 'fix', run: () => fixDesign(id, fix) }; openGate(); return; }
      cardErr(card, j.message || 'That fix did not work. Please try again.');
      return;
    }
    const idx = S.batch.images.findIndex((x) => x.id === id);
    const next = Object.assign({}, j.images[0], { fixedFrom: id });
    S.batch.images[idx] = next;
    const fresh = cardFor(next, idx, true);
    card.replaceWith(fresh);
    setQuota();
    remember();
    statusEl.textContent = next.check && next.check.ok === false
      ? 'Here is your fixed design. It may still have a mistake, so check it closely.'
      : 'Here is your fixed design.';
    $('[data-act="use"]', fresh).focus({ preventScroll: true });
    track('ardor_realestate_ai_fixed', { style: S.batch.style });
  }

  function validBox(lb) {
    return Array.isArray(lb) && lb.length === 4 && lb.every((n) => typeof n === 'number' && Number.isFinite(n)) ? lb.map((n) => Math.min(1, Math.max(0, n))) : null;
  }
  function handoffUrl(aiId, b, logoId, lb, ends) {
    const sc = signOf(b.sign);
    let u = `${BUILDER}${BUILDER.indexOf('?') === -1 ? '?' : '&'}ai=${enc(aiId)}&sign=${enc(b.sign || DEFAULT_SIGN)}&face=${enc(b.face || 'front')}`;
    if (isRider(b.face)) {
      const rs = riderOf(sc, b.rider);
      if (rs) u += `&rider=${enc(rs)}`;
    }
    if (ends === 'smooth') u += '&ends=smooth';
    if (logoId) {
      u += `&logo=${enc(logoId)}`;
      if (lb) u += `&lb=${lb.map((n) => n.toFixed(4)).join(',')}`;
    }
    return u;
  }
  async function useDesign(id, ends) {
    if (S.busy || !S.batch) return;
    const card = findCard(id);
    const b = S.batch;
    const img = b.images.find((x) => x.id === id);
    if (!card || !img) return;
    cardErr(card, '');
    S.busy = true;
    setBusyUi(true);
    const done = cardBusy(card, 'Making a sharp, print-ready version…', 'about 30–60 seconds', 25);
    statusEl.textContent = 'Making a sharp, print-ready version… about 30–60 seconds.';
    const token = await botToken();
    const j = await api('/api/banner/final', withEmail({ visitor, token, imageId: id }));
    if (j.finalsLeft != null) S.finalsLeft = j.finalsLeft;
    if (!j.ok || !j.image || !j.image.id) {
      done();
      S.busy = false;
      setBusyUi(false);
      statusEl.textContent = '';
      if (j.error === 'need_email') { S.pending = { kind: 'final', run: () => useDesign(id, ends) }; openGate(); return; }
      cardErr(card, j.message || "We couldn't make the print version. Please try again.");
      return;
    }
    const fin = j.image;
    const lb = validBox(fin.check && fin.check.logoBox) || validBox(img.check && img.check.logoBox);
    const url = handoffUrl(fin.id, b, b.logoId, lb, ends);
    const sc = signOf(b.sign);
    const q = sc && faceOf(sc, b.face, b.rider);
    const pick = {
      v: 1, ai: fin.id, url: fin.url, w: fin.w || 0, h: fin.h || 0,
      sign: b.sign, family: sc ? sc.f : '', model: sc ? sc.f : '', signName: sc ? sc.n : '',
      piece: isRider(b.face) ? 'rider' : 'sign', rider: isRider(b.face) ? riderOf(sc, b.rider) : null,
      sides: sc ? piecesOf(sc, b.face, b.rider).length : 1, face: b.face || 'front', faceName: faceName(b.face),
      visibleIn: q ? { w: q[1], h: q[2] } : null,
      ends: ends === 'smooth' ? 'smooth' : 'stretch',
      reqFt: { w: b.w, h: b.h }, logo: b.logoId || null, lb: lb || null,
      preview: id, lines: b.lines, style: b.style, idea: b.idea || '', at: Date.now()
    };
    sset(PICK_KEY, pick);
    remember();
    track('ardor_realestate_ai_design_used', { style: b.style, sign: b.sign, face: b.face, rider: pick.rider || '', logo: !!b.logoId, ends: ends || '' });
    $('.abi__busy-t', card).textContent = 'Opening the real estate sign designer…';
    $('.abi__busy-s', card).textContent = '';
    statusEl.textContent = 'Opening the real estate sign designer…';
    const ev = new CustomEvent('ardor:realestate-ai-handoff', { bubbles: true, cancelable: true, detail: { url, pick, image: fin, preview: img, batch: b } });
    if (root.dispatchEvent(ev)) { window.location.assign(url); return; }
    done();
    S.busy = false;
    setBusyUi(false);
  }

  form.addEventListener('submit', (e) => { e.preventDefault(); generate(); });
  againBtn.addEventListener('click', () => generate());
  editBtn.addEventListener('click', () => {
    form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setTimeout(() => lineIns.headline.focus({ preventScroll: true }), 350);
  });

  /* ---------- email unlock (same as the sticker generator: Shopify customer form into a hidden iframe) ---------- */
  function openGate() {
    showErr('', gateErr);
    gateEmail.value = email || '';
    if (gateN) gateN.textContent = String(S.emailBanners);
    if (gate.showModal) { try { gate.showModal(); } catch (e) { gate.setAttribute('open', ''); } }
    else gate.setAttribute('open', '');
    setTimeout(() => gateEmail.focus(), 60);
    track('ardor_realestate_ai_gate_shown', {});
  }
  function closeGate() { if (gate.close) gate.close(); else gate.removeAttribute('open'); }
  $('[data-abi-gate-close]').addEventListener('click', closeGate);
  gate.addEventListener('click', (e) => { if (e.target === gate) closeGate(); });
  function customerForm() {
    let f = root.querySelector('form#abi-customer');
    if (!f) {
      f = document.createElement('form');
      f.id = 'abi-customer';
      f.method = 'post';
      f.action = '/contact#abi-customer';
      f.className = 'abi__customer';
      f.innerHTML = '<input type="hidden" name="form_type" value="customer"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="contact[tags]" value="newsletter,ai-real-estate-sign-generator,ardor-realestate-builder"><input type="hidden" name="contact[email]" data-abi-customer-email>';
      root.appendChild(f);
    }
    return f;
  }
  function subscribe(addr) {
    const f = customerForm();
    const field = f.querySelector('[name="contact[email]"]');
    if (field) field.value = addr;
    f.target = 'abi-sink';
    try { if (f.requestSubmit) f.requestSubmit(); else f.submit(); } catch (e) { try { f.submit(); } catch (e2) { /* ignore */ } }
  }
  gateForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    const addr = gateEmail.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(addr)) { showErr('Please enter a valid email.', gateErr); gateEmail.focus(); return; }
    email = addr;
    store.set('wsIdeaEmail', addr);
    S.hasEmail = true;
    subscribe(addr);
    track('ardor_realestate_ai_email', {});
    const q = await api(`/api/banner/quota?visitor=${enc(visitor)}&email=${enc(addr)}`);
    if (q.ok) {
      S.bannersLeft = q.bannersLeft;
      S.fixesLeft = q.fixesLeft;
      S.finalsLeft = q.finalsLeft;
      if (q.emailBanners) S.emailBanners = q.emailBanners;
    }
    setQuota();
    closeGate();
    const next = S.pending;
    S.pending = null;
    if (next && !(next.kind === 'generate' && S.bannersLeft === 0)) next.run();
  });

  /* ---------- start ---------- */
  Object.keys(lineIns).forEach((k) => syncCount(k, lineIns[k]));
  syncCount('notes', notesIn);
  const params = new URL(window.location.href).searchParams;
  const last = sget(LAST_KEY);
  if (last && last.form && Date.now() - (last.at || 0) < 36e5 * 24) {
    const f = last.form;
    lineIns.headline.value = f.headline || '';
    lineIns.subline.value = f.subline || '';
    lineIns.details.value = f.details || '';
    notesIn.value = f.notes || '';
    Object.keys(lineIns).forEach((k) => syncCount(k, lineIns[k]));
    syncCount('notes', notesIn);
    setStyle(f.style || 'bold');
    if (f.idea && IDEAS[f.idea]) { S.idea = f.idea; ideaChips.forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.idea === f.idea))); lineIns.subline.placeholder = IDEAS[f.idea].sub; }
    if (f.sign && signOf(f.sign)) setSign(f.sign, f.face, f.rider);
    if (last.logo && last.logo.id) setLogo({ blob: null, id: last.logo.id, name: last.logo.name, w: last.logo.w, h: last.logo.h, thumb: last.logo.thumbData, thumbData: last.logo.thumbData });
    if (last.batch && last.batch.images && last.batch.images.length) { S.batch = last.batch; renderResults(); }
  }
  const ps = String(params.get('sign') || '').toUpperCase();
  const psv = SIGNS.find((x) => x.k.toUpperCase() === ps);
  const pf = String(params.get('face') || '').toLowerCase();
  const pr = String(params.get('rider') || '').toLowerCase().replace(/\s+/g, '');
  setSign(psv ? psv.k : S.sign, FACE_NAMES[pf] ? pf : S.face, pr || S.rider);

  (async () => {
    const q = await api(`/api/banner/quota?visitor=${enc(visitor)}${email ? `&email=${enc(email)}` : ''}`, null, 20000);
    if (!q.ok) return;
    if (q.enabled === false) {
      S.off = true;
      goBtn.disabled = true;
      showErr('The real estate sign generator is taking a short break. Please try again later.');
    }
    S.bannersLeft = q.bannersLeft;
    S.fixesLeft = q.fixesLeft;
    S.finalsLeft = q.finalsLeft;
    S.hasEmail = !!q.hasEmail;
    if (q.freeBanners) S.freeBanners = q.freeBanners;
    if (q.emailBanners) S.emailBanners = q.emailBanners;
    setQuota();
  })();
  if (SITEKEY) loadTurnstile();
})();
